<template>
  <div class="chief-search">
    <div class="dep-create-form-search">
      <div class="dep-create-form-search__label">
        {{ $t('orgs.search_employee_by_settings') }}
      </div>
      <div class="dep-create-form-search__inputs">
        <div class="el-input">
          <input
            type="text"
            class="el-input__inner"
            :placeholder="$t('labels.surname')"
            v-model="query.last_name"
            @keyup.enter="loadList"
            ref='searchFirstInput'
          >
        </div>
        <div class="el-input">
          <input
            type="text"
            class="el-input__inner"
            :placeholder="$t('labels.name')"
            v-model="query.first_name"
            @keyup.enter="loadList"
          >
        </div>
        <div class="el-input">
          <input
            type="text"
            class="el-input__inner"
            :placeholder="$t('labels.middle_name')"
            v-model="query.middle_name"
            @keyup.enter="loadList"
          >
        </div>
        <div class="dep-create-form-search__button">
          <el-button type="primary" size="medium" @click="loadList">{{ $t('labels.search_employee') }}</el-button>
          <el-button type="danger" plain size="medium" @click="clearQuery">{{ $t('labels.clear') }}</el-button>
        </div>
      </div>
    </div>
    <div class="chiefs-list ps" :class="{bordered: userList.length > 0}">
      <ui-scrollbar class="chiefs-list__container">
        <transition-group name="fade">
          <el-row v-for="user in userList" :key="user.getId()" class="chief" style="animation-duration: 0.15s">
            <el-col :sm="14">
              <avatar :upic="user.getUpic()"
                      :name="user.getLastName()"
                      size="ic">
              </avatar>
              <span class="chief__name">
                {{user.getFullName()}}
              </span>
            </el-col>
            <el-col :sm="10" class="chief__select">
              <el-button size="medium" @click="$emit('selected',user)">{{ $t('orgs.select_director') }}</el-button>
            </el-col>
          </el-row>
        </transition-group>
      </ui-scrollbar>
    </div>
    <div v-if="userList.length===0 && loaded" class="nothingFound">
      <img src="static/img/icon_sad.svg"/> {{ $t('labels.employee_not_founded') }}
    </div>
  </div>
</template>

<script>
// import listAgrerator from 'src/services/userList'
import Avatar from '@/components/Avatar/avatar'

export default {
  name: 'chiefFind',
  components: {
    Avatar
  },
  data () {
    return {
      query: {
        first_name: null,
        last_name: null,
        middle_name: null
      },
      userList: [],
      showSearchInputs: false,
      showClearQuery: false,
      loaded: false
    }
  },
  methods: {
    clearSearch () {
      this.query = {
        first_name: null,
        last_name: null,
        middle_name: null
      };
    },
    clearQuery () {
      this.clearSearch();
      this.showClearQuery = false;
      this.loaded = false;
      this.userList = [];
    },
    async loadList () {
      if (!this.query.first_name &&
        !this.query.last_name &&
        !this.query.middle_name) {
        return false;
      }

      this.showSearchInputs = false;
      this.showClearQuery = true;
      this.loaded = false;

      let query = {}
      for (let col in this.query) {
        if (this.query[col] && this.query[col].trim() !== '') {
          query[col] = this.query[col].trim()
        }
      }
      try {
        let response = await this.$store.dispatch('users/findUsers',
          {
            limit: 100,
            offset: 0,
            ...query
          });
        this.userList = response.users;
        this.loaded = true;
        return response.users
      } catch (resp) {
        console.error('LOG: loadList -> resp', resp)
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.error'),
          message: this.$t('labels.user_not_founded'),
          type: 'error',
          offset: 75,
          duration: 2000
        });
      }
    },
    reset () {
      this.clearSearch();
      this.clearQuery();
    }
  }
}
</script>

<style lang="scss">
  @import 'src/assets/sass/paper/variables';

  .chief-search {
    margin-bottom: 20px;
    .dep-create-form-search {
      position: relative;
      margin-bottom: 20px;

      &__wrapp {
        max-width: 400px;
      }

      &__label {
        margin-bottom: 15px;
        font-size: 16px;
        color: #9F9F9F;
      }

      &__inputs {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 300px;
        grid-column-gap: 15px;
        grid-row-gap: 15px;
        margin-bottom: 0;
        .el-input {
          margin-bottom: 0;
        }

        @media (max-width: $screen-sm) {
          grid-template-columns: 1fr;
        }
      }

      &__button {
        text-align: right;

        button {
          @media (max-width: $screen-sm) {
            width: 100%;
          }
          font-weight: 300;
          margin-bottom: 10px;
        }
      }

      &__cancel {
        display: none;
        margin-left: 10px;
        color: $link-color;
      }

      &__clear {
        color: $link-color;
        cursor: pointer;
      }
    }

    .chiefs-list {
      margin-top: 20px;
      max-height: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      &.bordered {
        border-top: 1px solid #EDF1F7;
        border-bottom: 1px solid #EDF1F7;
        padding: 10px 0;
        max-height: 350px;
      }
      .ps__scrollbar-y-rail {
        z-index: 2;
      }
      &__container {
        position: relative;
        z-index: 1;
      }
      &__label {
        margin-bottom: 10px;
        font-weight: 700;
      }
      .chief {
        background: #F9FAFC;
        margin: 10px 0;
        padding: 0 20px;
        .userpic {
          vertical-align: middle;
          margin: 15px 20px 15px 0;
        }
        &__name {
          max-width: calc(100% - 65px);
          display: inline-block;
          vertical-align: middle;
          margin: 15px 0;
        }
        &__select {
          text-align: right;
          margin: 15px 0;
          @media (max-width: $screen-sm) {
            text-align: center;
            margin-top: 0;
            button {
              width: 100%;
            }
          }
        }
      }
    }

    .nothingFound {
      color: #F25556;
    }
  }
</style>